import { ChangeDetectionStrategy, Component, EventEmitter, inject, Injector, Input, Output } from '@angular/core';
import { TypeService } from '../../../../../services/type/type-service';
import { map } from 'rxjs/operators';
import { PhoneDropdownItem } from '../../../../../models/shared/phone-dropdown-item';
import { EmployerRecordPrimaryContactFormGroup } from '../../../../../forms/employer-record-primary-contact-form-group';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmployerRecordContactRemoveModalComponent } from '../../employer-record-contact-remove-modal/employer-record-contact-remove-modal.component';
import { ModalUtils } from '../../../../../utils/modal-utils';

@Component({
  selector: 'app-employer-record-primary-contact-accordion',
  templateUrl: './employer-record-primary-contact-accordion.component.html',
  styleUrls: ['../employer-record-accordion.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmployerRecordPrimaryContactAccordionComponent {
  @Input() formGroup!: EmployerRecordPrimaryContactFormGroup;
  @Input() isExpanded = false;
  @Input() formSubmitted = false;
  @Output() toggle = new EventEmitter<void>();
  @Output() removeContact = new EventEmitter<void>();

  private typeService = inject(TypeService);
  private ngbModal = inject(NgbModal);
  private injector = inject(Injector);

  public countryCodeDropdowns$ = this.typeService.countries$.pipe(
    map(countries => countries?.map(c => new PhoneDropdownItem(c)))
  );

  public customErrorMessages = {
    firstName: {
      required: $localize`First Name required`
    },
    lastName: {
      required: $localize`Last Name required`
    },
    phoneNumber: {
      required: $localize`Phone Number required`
    },
    email: {
      required: $localize`Email required`
    }
  };

  public remove(): void {
    const modalRef = this.ngbModal.open(
      EmployerRecordContactRemoveModalComponent,
      ModalUtils.defaultModalOptions(this.injector)
    );
    modalRef.componentInstance.setEmployerContactName(
      this.formGroup.value.firstName + ' ' + this.formGroup.value.lastName
    );
    modalRef.result.then(result => {
      if (result) this.removeContact.emit();
    });
  }
}
